import Check from '@Icons/check.svg?react'

function StepDot({
  title = '',
  isActive = false,
  isPassed = false,
  isLast = false,
}: {
  title: string
  isActive?: boolean
  isPassed?: boolean
  isLast?: boolean
}): JSX.Element {
  return (
    <div className="flex flex-col items-center w-28 min-h-20 relative z-[1]">
      <span
        className={`flex border rounded-full w-6 h-6 items-center justify-center mb-2.5${isActive || isPassed ? ' bg-primary-50 border-primary-600' : ' bg-gray-50 border-gray-300'}${isActive ? ' shadow-[0_0_3px_5px] shadow-primary-300' : ''}`}
      >
        {isPassed ? (
          <Check />
        ) : (
          <span
            className={`rounded-full border w-2 h-2${isActive || isPassed ? ' bg-primary-600  border-primary-600' : ' bg-gray-300 border-gray-300'}`}
          ></span>
        )}
      </span>
      <span
        className={`text-[0.8rem] font-medium text-center${isActive || isPassed ? ' text-primary-700' : ' text-gray-800'}`}
      >
        {title}
      </span>
    </div>
  )
}

function StepsProgress({
  steps = [],
  currentStep = 2,
  className = 'mt-4',
}: {
  steps?: string[]
  currentStep?: number
  className?: string
}): JSX.Element {
  const progressWidth = Math.max(
    0,
    Math.min(100, (100 / (steps.length - 1)) * (currentStep - 1)),
  )

  return (
    <div className={`flex flex-col${className ? ` ${className}` : ''}`}>
      <div className="relative block w-full max-w-[720px] mx-auto overflow-x-hidden py-3">
        <div
          id="batch-import-step-progress-bg"
          className="relative z-[0] left-14 top-4 h-[1.6px] -translate-y-[0.8px] w-[calc(100%-7rem)] bg-gray-100"
        >
          <div
            id="batch-import-step-progress"
            className="absolute z-[1] left-0 top-0 h-[1.6px] -translate-y-[0.8px] bg-primary-600 opacity-90"
            style={{
              transition: 'width 0.3s ease',
              width: `${progressWidth}%`,
            }}
          ></div>
        </div>
        <div className="flex justify-between items-center w-full">
          {steps.map((step, index) => (
            <StepDot
              key={index}
              title={step}
              isActive={index === currentStep - 1}
              isPassed={index < currentStep - 1}
              isLast={index === steps.length - 1}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default StepsProgress
